export default {"src":"/_next/static/media/type_etablissement.916acf04.svg","height":771,"width":1010};